module.exports = __webpack_public_path__ + "static/map-and-compass-people-bcc0677ccc80fab937a5841f19552ada.jpeg";